<template>
  <div class="debug" v-if="admin">
    <div slot="data">
      <div>
        {{ debugInformation }}
      </div>
      <div>
        <p class="notice">Results process</p>
        <ol>
          <li>get user's answer</li>
          <li>get all products answers_weights.</li>
          <li>
            find find coresponding value in 2d matrixArray. eg. if user sects 1
            and and answers for three products are 1,2,3 respectivey.
            coresponding value in matrix will be found using the folling pair
            (useranswer,product answer) ie
            <br />(1,1) <br />(1,2) <br />(1,3)
          </li>
          <li>
            value retrived from matrix will be multipled by thew weight value on
            answer
          </li>
        </ol>
      </div>
      <div>
        <p class="notice">siteSettings</p>
        {{ siteSettings }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Debug",

  computed: {
    ...mapState(["siteSettings", "admin", "debugInformation"]),
    bottom() {
      const { height } = this.siteSettings;
      //console.log(this.siteSettings);
      const heightNumber = parseInt(height);
      const type = height.replace(/[0-9]/g, "");
      return `-${heightNumber + 10}${type}`;
    }
  }
};
</script>
